import {
  Grid,
  Typography,
  Button,
  Card,
  TextField
} from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import EmployeeDropDown from '../workModel/common/EmployeeDropDown';
import { useForm } from 'react-hook-form';
import { AddWorkModel, ApplyWorkFromHomeModel } from 'src/models/leave';
import Calander from '../workModel/common/Calander';
import { 
  getDayCount, 
  getWorkModelConfigurations, 
  workFromHomeRequest, 
  getAllWorkFromHomeRequests, 
  workFromHomeRequestApprovalProcess } from 'src/services/leaveService';
import { useDispatch, useSelector } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import WorkModelTypeDropdown from '../workModel/common/WorkModelTypeDropdown';
import CalendarRangePicker from '../common/CalendarRangePicker';
import { getReporterByEmpId } from 'src/services/employeeService';
import moment from 'moment';
import { getSingleProjectAllocationDetails } from 'src/services/projectService';
import { RootStateType } from 'src/store/RootReducer';
import AllocationTable from './common/AllocationTable';
import { useAppSelector } from 'src/hooks/hooks';
import SnackBar from 'src/components/SnackBar/SnackBar';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import WfhRejectReasonForm from './common/WfhRejectReasonForm';
  
interface ApplyWorkFromHomeProps {
  permissions: any;
}
  
const ApplyWorkFromHome: React.FC<ApplyWorkFromHomeProps> = ({ permissions }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const { requestId } = useParams();

  const [disable, setDisable] = useState(false);

  let initialValues = {
    requestDate: moment(new Date()).format('YYYY-MM-DD'),
    dateRange: null,
    employeeId: null,
    fromDate: null,
    toDate: null,
    daysCount: null,
    reason: null,
    pmRmId: null,
    reportingManagerId: null,
    attachmentName: null,
    wfhConfigurationId: null,
    status: 'PENDING'
  } as ApplyWorkFromHomeModel;

  let initialWorkModelValues = {
    employeeIds: null,
    fromDate: null,
    toDate: null,
    type: null,
    frequency: null,
    selectedDates: []
  } as AddWorkModel;

  const [workModelValues, setWorkModelValues] = useState(initialWorkModelValues as AddWorkModel);
  const [workFromHomeValues, setWorkFromHomeValues] = useState(initialValues as ApplyWorkFromHomeModel);
  const { register, handleSubmit, reset, setValue, formState: { errors }, clearErrors, setError } = useForm<ApplyWorkFromHomeModel>();

  const [mainProjectManager, setMainProjectManager] = useState<any>('');
  const [resourceAllocations, setResourceAllocations] = useState<any>();

  const [attachment, setAttachment] = useState<any>({});
  const [wfhConfigurationId, setWfhConfigurationId] = useState<number>();
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [pmRmId, setPmRmId] = useState('');
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openRejectReasonForm, setOpenRejectReasonForm] = useState(false);
  const [calendarKey, setCalendarKey] = useState(0);

  const isHR = appUser?.Roles.split(',').includes('Super User') ||
  appUser?.Roles.split(',').includes('HR Manager') ||
  appUser?.Roles.split(',').includes('Assistant HR Manager') ||
  appUser?.Roles.split(',').includes('HR Executive');

  const isReportingManager = useSelector(
    (state: RootStateType) => state.appReducer.user.IsReportingManager
  );
  const isProjectManager = useSelector(
    (state: RootStateType) => state.appReducer.user.IsProjectManager
  );
  const userId = useSelector(
    (state: RootStateType) => state.appReducer.user.EmployeeId
  );
  
  const onSubmit = (data?: ApplyWorkFromHomeModel) => {
    dispatch(AppActions.showLoader());

    const payload: ApplyWorkFromHomeModel = {
      employeeId : workFromHomeValues.employeeId,
      wfhConfigurationId: workFromHomeValues.wfhConfigurationId,
      fromDate: workFromHomeValues.fromDate,
      toDate: workFromHomeValues.toDate,
      reason: workFromHomeValues.reason,
      daysCount: workFromHomeValues.daysCount,
      status: workFromHomeValues.status,
      requestDate: workFromHomeValues.requestDate,
      pmRmId: workFromHomeValues.pmRmId,
      reportingManagerId: workFromHomeValues.reportingManagerId,
      reportingManagerName: workFromHomeValues.reportingManagerName,
      attachmentName: workFromHomeValues.attachmentName
    };

    const formData = new FormData();
    if (Object.keys(attachment).length !== 0) {
      formData.append('file', attachment.file);
    }
    formData.append('request', JSON.stringify(payload));

    workFromHomeRequest(formData).then((res: any) => {
      if (res.data?.statusCode === 200) {
        onReset();
        setSnackBarMessage('You’ve created the WFH Request successfully.');
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        setWorkModelValues(initialWorkModelValues);
        setWfhConfigurationId(null);
      }else{
        setSnackBarMessage( res.data?.message ? res.data?.message : 'Unable create a WFH request.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      }
      dispatch(AppActions.hideLoader());
    }, (err: any) => {
      dispatch(AppActions.hideLoader());
      setSnackBarMessage( err?.request?.response ? err?.request?.response : 'Unable create a WFH request.');
      setSnackbarSeverity('error');
      setSnackBarOpen(true);
    });
  };

  //if url has path variable 
  useEffect(() => {
    if(requestId){
      setDisable(true);
      setWorkFromHomeValues({
        requestDate: moment(new Date()).format('YYYY-MM-DD'),
        dateRange: null,
        employeeId: null,
        fromDate: null,
        toDate: null,
        daysCount: null,
        reason: null,
        pmRmId: null,
        reportingManagerId: null,
        attachmentName: null,
        wfhConfigurationId: null,
        status: null
      })
      getWorkFromHomeDetailsById(requestId);
    }
  }, [requestId]);

  const getWorkFromHomeDetailsById = (id: any) => {
    dispatch(AppActions.showLoader());
    const payload = {
      requestId: Number(id),
      pmRmIds: null,
      employeeIds: null,
      status: null,
      fromDate: null,
      toDate: null,
      isMyRequest: true
    };
    let pageNo = 0;
    let pageSize = 1;

    getAllWorkFromHomeRequests(payload, pageNo, pageSize).then((res: any) => {
      if(res.data?.statusCode === 200) {
        const data = res?.data?.data;
        setWorkFromHomeValues(data?.wfhRequestSummery[0]);
        getProjectAllocationDetails(data?.wfhRequestSummery[0].employeeId ,data?.wfhRequestSummery[0]?.fromDate, data?.wfhRequestSummery[0]?.toDate);
        setPmRmId(data?.wfhRequestSummery[0]?.pmRmId);
      }else{
        setSnackBarMessage( res.data?.message ? res.data?.message : 'Unable retrieve a WFH detail.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      }
      dispatch(AppActions.hideLoader());
    }).catch((err: any) => {
      dispatch(AppActions.hideLoader());
      setSnackBarMessage( err?.request?.response ? err?.request?.response : 'Unable retrieve a WFH detail.');
      setSnackbarSeverity('error');
      setSnackBarOpen(true);
    })
  }


  useEffect(() => {
    if(workFromHomeValues?.employeeId){
      dispatch(AppActions.showLoader());
      const payload = {
        employeeIds: [workFromHomeValues?.employeeId],
        types: null,
        fromDate: null,
        toDate: null
      };

      getWorkModelConfigurations(payload, 0, 10).then((res) => {
        const data = res?.data?.data
        setWorkModelValues(data?.configurationSummery[data?.configurationSummery?.length - 1]);
        setWfhConfigurationId(data?.configurationSummery[data?.configurationSummery?.length - 1]?.id);
      });
      dispatch(AppActions.hideLoader());
      !requestId && getReporter(workFromHomeValues?.employeeId);
      
      setCalendarKey(prevKey => prevKey + 1);
    }
  }, [workFromHomeValues?.employeeId]);


  //get reporter
  const getReporter = async (empId) => {
    /* dispatch(AppActions.showLoader()); */
    const reporter = await getReporterByEmpId(empId);
    if(reporter?.data?.length > 0){
      clearErrors(['reportingManagerName', 'reportingManagerId']);
      setWorkFromHomeValues({
        ...workFromHomeValues,
        reportingManagerName: reporter?.data[0]?.name,
        reportingManagerId: reporter?.data[0]?.employeeId
      });
      setValue('reportingManagerName', reporter?.data[0]?.name);
      setValue('reportingManagerId', reporter?.data[0]?.employeeId);
      /* dispatch(AppActions.hideLoader()); */
    }
  };

  //get days count
  const getCount = (startDate, endDate) => {
    setValue('daysCount', 0);
    getDayCount(moment(startDate).format('DD/MM/YYYY'), 
    moment(endDate).format('DD/MM/YYYY'))
      .then((res) => {
        setWorkFromHomeValues({
          ...workFromHomeValues,
          daysCount: res?.data?.data,
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          dateRange: true
        });
        setValue('daysCount', res.data.data);
      })
      .catch((e) => {
        dispatch(AppActions.hideLoader());
        /* setSnackBarMessage(e.response?.data?.message);
        setSnackbarSeverity('Warning');
        setSnackBarOpen(true); */
        setValue('fromDate', null);
        setValue('toDate', null);
        setWorkFromHomeValues((prev) => ({
          ...prev,
          fromDate: null,
          toDate: null,
          dateRange: null
        }));
      });
  };

 //get project allocation within selected date range
  const getProjectAllocationDetails = (employeeId, startDate, endDate) => {
    const body = {
      employeeId: employeeId,
      filter: {
        startDate: startDate,
        endDate: endDate
      }
    };
    if (startDate && endDate) {
      dispatch(AppActions.showLoader());
      getSingleProjectAllocationDetails(body).then((res) => {
        setResourceAllocations(res.data);
        projectManagerHandling(res.data);
        dispatch(AppActions.hideLoader());
      }, (err) => {
        dispatch(AppActions.hideLoader());
      });
    }
  };


  const projectManagerHandling = (resourceRes: any) => {
    if(resourceRes?.allocations?.length > 0) {
      let selectedProjectManager = null;

      resourceRes.allocations.forEach((element: any) => {
        if(element.projectManagerId !== appUser.EmployeeId && element.projectManagerId) {
          if(element.type === 'Billable') {
            if(selectedProjectManager === null || selectedProjectManager.type !== 'Billable') {
              selectedProjectManager = element;
            }else if(element.allocation > selectedProjectManager.allocation && (selectedProjectManager.type === 'Billable')) {
              selectedProjectManager = element;
            }
          }else{
            if(selectedProjectManager === null) {
              selectedProjectManager = element;
            }else if(element.allocation > selectedProjectManager.allocation && (selectedProjectManager.type !== 'Billable')) {
              selectedProjectManager = element;
            }
          }
        }
      });
      setMainProjectManager(selectedProjectManager);
      setWorkFromHomeValues((prev) => ({
        ...prev,
        pmRmId : selectedProjectManager?.projectManagerId ? selectedProjectManager.projectManagerId : workFromHomeValues.reportingManagerId,
        wfhConfigurationId : Number(wfhConfigurationId)
      }));
    }else{
      setMainProjectManager(null);
      setWorkFromHomeValues((prev) => ({
        ...prev,
        pmRmId : workFromHomeValues.reportingManagerId,
        wfhConfigurationId : Number(wfhConfigurationId)
      }));
    }
  }

  const changeHandler = (event) => {
    if (event?.target) {
      clearErrors(['attachmentName'])
      const fileSize = (event.target.files[0]?.size / 1024 / 1024).toFixed(4);
      const attachmentName = event.target.files[0]?.name;

      setValue('attachmentName', attachmentName);
      setWorkFromHomeValues((prev) => ({
        ...prev,
        attachmentName: attachmentName
      }));

      const extensionsRegex = /(\.pdf|\.doc|\.docx|\.png|\.jpeg|\.jpg)$/i;
      if (!extensionsRegex.exec(attachmentName)) {
        setWorkFromHomeValues((prev) => ({
          ...prev,
          attachmentName: null
        }));
        setValue('attachmentName', null)
        setError('attachmentName', {
          type: 'manual',
          message: 'File format is incorrect.',
        });
      } else if (Number(fileSize) > 10) {
        setWorkFromHomeValues((prev) => ({
          ...prev,
          attachmentName: null
        }));
        setValue('attachmentName', null)
        setError('attachmentName', {
          type: 'manual',
          message: 'Please upload a file less than 10MB.',
        });
      } else {
        clearErrors(['attachmentName'])
        setAttachment({ file: event.target.files[0] });
      }
    }
  };

  const onReset = () => {
    reset();
    setWorkFromHomeValues(initialValues);
    setWorkModelValues(initialWorkModelValues);
    setWfhConfigurationId(null);
    setAttachment(null);
  };

  const validateConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const onApprovedWfhHandle = () => {
    const payload = {
      id: Number(requestId),
      status: 'APPROVED',
      rejectReason: null
    }
    setOpenConfirmation(false);
    whfApprovedOrRejectHandle(payload, 'Approved')
  }

  const onCloseRejectReasonForm = () => {
    setOpenRejectReasonForm(false);
  };

  const onRejectWfhHandle = (e: any) => {
    const payload = {
      id: Number(requestId),
      status: 'REJECTED',
      rejectReason: e.reason
    }
    whfApprovedOrRejectHandle(payload, 'Rejected')
  }

  const whfApprovedOrRejectHandle = (payload: any, type: string) => {
    dispatch(AppActions.showLoader());
    workFromHomeRequestApprovalProcess(payload).then((res: any) => {
      if(res.data?.statusCode === 200) {
        onCloseRejectReasonForm();
        setSnackBarMessage( res.data?.message ? res.data?.message : `You’ve ${type} the work from home request successfully.`);
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        getWorkFromHomeDetailsById(requestId);
      }else{
        onCloseRejectReasonForm();
        setSnackBarMessage( res.data?.message ? res.data?.message : `Unable ${type} a work from home request.`);
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      }
      dispatch(AppActions.hideLoader());
    }).catch((err: any) => {
      dispatch(AppActions.hideLoader());
      onCloseRejectReasonForm();
      setSnackBarMessage( err?.request?.response ? err?.request?.response : `Unable ${type} a work from home request.`);
      setSnackbarSeverity('error');
      setSnackBarOpen(true);
    })
  }

  return (
    <Fragment>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Apply Work From Home
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          {/* show only if logged user is HR or RM/PM */}
          {(isHR || isReportingManager === true || isProjectManager === true) &&
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={() => {
                navigate(`/work-from-home/requests`);
              }}
            >
              WFH history
            </Button>
          }
          <Button
            sx={{
              ml: 1,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={() => {
              navigate(`/work-from-home`);
            }}
          >
            My WFH history
          </Button>
        </Grid>
      </Grid>
      <div className='resource-pool work-from-home'>
        <Grid container sx={{ mt: 1, mb: 1, px: 0, mx: 0, pl: 0 }}>
          <Grid xs={8}>
            <Card>
              <form  onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} sx={{p: 3}}>
                  <Grid item xs={6}>
                    <EmployeeDropDown
                      disabled={disable}
                      {...register('employeeId', { required: 'Employee is required' })}
                      value={workFromHomeValues?.employeeId || ''}
                      onChange={(e: any) => {
                        setWorkFromHomeValues((prev) => ({
                          ...prev,
                          employeeId: e.target.value
                        }));
                        setValue('employeeId', e.target.value);
                        clearErrors(['employeeId']);
                      }}/>
                    <Typography style={{paddingLeft: 15, paddingRight: 15, fontSize: '11px'}} color="red">
                      {errors.employeeId  && errors.employeeId.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <WorkModelTypeDropdown
                      required={false}
                      disabled={true}
                      value={workModelValues?.type || ''}
                      onChange={(e: any) => {}}/>
                  </Grid>
                  <Grid className="date-range" item xs={6}>
                    <CalendarRangePicker
                      disabled={disable}
                      {...register('dateRange', { required: 'Date is required' })}
                      fullWidth
                      title="Date(s)"
                      onApply={(event, picker) => {
                        clearErrors(['fromDate', 'toDate', 'dateRange', 'daysCount']);
                        setValue('fromDate', moment(picker.startDate).format('YYYY-MM-DD'));
                        setValue('toDate', moment(picker.endDate).format('YYYY-MM-DD'));
                        setValue('dateRange', true);

                        //get days count
                        getCount(picker.startDate,picker.endDate);

                        //get project allocation within selected date range
                        getProjectAllocationDetails(
                          workFromHomeValues?.employeeId,
                          moment(picker.startDate).format('YYYY-MM-DD'),
                          moment(picker.endDate).format('YYYY-MM-DD')
                        );
                      }}
                      fromDate={workFromHomeValues?.fromDate && new Date(workFromHomeValues?.fromDate)}
                      toDate={workFromHomeValues?.toDate && new Date(workFromHomeValues?.toDate)}
                    />
                    <Typography style={{paddingLeft: 15, paddingRight: 15, fontSize: '11px'}} color="red">
                      {errors.dateRange  && errors.dateRange.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight="light" variant="h5">
                      Days Count<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      sx={{ mt: 1 }}
                      {...register('daysCount', { required: 'Day Count is required' })}
                      inputProps={{ maxLength: 30 }}
                      size="small"
                      fullWidth
                      placeholder="Enter Days Count"
                      variant="outlined"
                      value={workFromHomeValues?.daysCount || ''}
                      disabled
                      defaultValue={''}
                    />
                    <Typography style={{paddingLeft: 15, paddingRight: 15, fontSize: '11px'}} color="red">
                      {errors.daysCount  && errors.daysCount.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography fontWeight="light" variant="h5">
                      Reason<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      {...register('reason', { required: 'Reason is required' })}
                      disabled={disable}
                      sx={{ mt: 1 }}
                      size="small"
                      multiline
                      rows={3}
                      className="input-text"
                      inputProps={{
                        style: {
                          fontSize: '13px'
                        },
                        maxLength: 500
                      }}
                      fullWidth
                      placeholder="Enter Reason"
                      variant="outlined"
                      value={workFromHomeValues.reason || ''}
                      onChange={(e) => {
                        clearErrors(['reason']);
                        setWorkFromHomeValues((prev) => ({
                          ...prev,
                          reason:  e.target.value
                        }));
                        setValue('reason', e.target.value);
                      }}
                    />
                    <Typography style={{paddingLeft: 15, paddingRight: 15, fontSize: '11px'}} color="red">
                      {errors.reason  && errors.reason.message}
                    </Typography>
                    <Typography
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginRight: '1rem',
                        fontSize: '12px',
                        /* marginTop: leaveReasonError ? '-1rem' :'' */
                      }}
                    >
                      {workFromHomeValues?.reason?.length ? 
                      workFromHomeValues?.reason?.length : 0} / 500
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight="light" variant="h5">
                      Reporting Manager<span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <TextField
                      {...register('reportingManagerName', { required: 'Reporting Manager is required' })}
                      sx={{ mt: 1 }}
                      inputProps={{ maxLength: 30 }}
                      size="small"
                      fullWidth
                      placeholder="Enter Reporting Manager"
                      variant="outlined"
                      disabled
                      value={workFromHomeValues.reportingManagerName}
                    />
                    <Typography style={{paddingLeft: 15, paddingRight: 15, fontSize: '11px'}} color="red">
                      {errors.reportingManagerName  && errors.reportingManagerName.message}
                    </Typography>
                  </Grid>
                  <Fragment>
                    <Grid item xs={4}>
                      <Typography fontWeight="light" variant="h5">
                        Attachment
                      </Typography>
                      <TextField
                        {...register('attachmentName')}
                        sx={{ mt: 1 }}
                        fullWidth
                        size="small"
                        variant="outlined"
                        disabled
                        value={workFromHomeValues?.attachmentName ? workFromHomeValues?.attachmentName 
                          : 'No File Selected'}
                      />
                      {!errors.attachmentName && <p className='max-file-text'>Maximum file upload size: 10MB</p>}
                      <Typography style={{paddingLeft: 15, paddingRight: 15, fontSize: '11px'}} color="red">
                        {errors.attachmentName  && errors.attachmentName.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ paddingLeft: '1rem' }}>
                      <Typography color='white' fontWeight="light" variant="h5">
                        Attachment
                      </Typography>
                      <Button
                        disabled={disable}
                        sx={{ mt: 1 }}
                        style={{
                          border: '1px solid #5569ff',
                          color: '#5569ff',
                          padding: '6px 8px',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: 'normal',
                          width: '100%'
                        }}
                      >
                        Choose
                        <input
                          disabled={disable}
                          type="file"
                          name="attachmentName"
                          id="upload-attachment"
                          accept=".pdf, .doc, .docx, .png, .jpeg, .jpg"
                          onChange={changeHandler}
                        />
                      </Button>
                    </Grid>
                  </Fragment>
                  {requestId && (
                    <>
                      <Grid item xs={6}>
                        <Typography fontWeight="light" variant="h5">
                          Status
                        </Typography>
                        <TextField
                          sx={{ mt: 1 }}
                          inputProps={{ maxLength: 30 }}
                          size="small"
                          fullWidth
                          placeholder="Enter Status"
                          variant="outlined"
                          disabled
                          value={workFromHomeValues.status}
                        />
                      </Grid>
                      {workFromHomeValues.rejectReason && (
                        <>
                          <Grid item xs={12}>
                            <Typography fontWeight="light" variant="h5">
                              Reject Reason
                            </Typography>
                            <TextField
                              disabled
                              sx={{ mt: 1 }}
                              size="small"
                              multiline
                              rows={3}
                              className="input-text"
                              inputProps={{
                                style: {
                                  fontSize: '13px'
                                }
                              }}
                              fullWidth
                              placeholder="Enter Reject Reason"
                              variant="outlined"
                              value={workFromHomeValues.rejectReason || ''}
                            />
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                </Grid>
                {(workFromHomeValues.fromDate && workFromHomeValues.toDate) &&
                  <AllocationTable
                    resource={resourceAllocations}
                    mainProjectManager={mainProjectManager}
                  />
                }
                {!disable &&
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', p: 3, pt:2 }}>
                    <Button
                      sx={{
                        width: '10%',
                        fontWeight: 'normal',
                        background: '#F5F7FF',
                        fontSize: '13px'
                      }}
                      onClick={onReset}
                    >
                      Reset
                    </Button>
                    <Button
                      sx={{
                        ml: 2,
                        width: '10%',
                        fontSize: '13px',
                        fontWeight: 'normal',
                        background: '#0069E4'
                      }}
                      variant="contained"
                      type="submit"
                      disabled={isLoading || !wfhConfigurationId}
                    >
                      Apply
                    </Button>
                  </Grid>
                }
                {(requestId && (userId === pmRmId)) &&
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', p: 3, pt:2 }}>
                    <Button
                      sx={{
                        width: '100px',
                        fontWeight: 'normal',
                        color: 'red',
                        fontSize: '13px',
                        background: '#F5F7FF'
                      }}
                      onClick={() => setOpenRejectReasonForm(true)}
                    >
                      Reject
                    </Button>
                    <Button
                      sx={{
                        ml: 2,
                        width: '100px',
                        fontSize: '13px',
                        fontWeight: 'normal',
                        background: '#0069E4'
                      }}
                      variant="contained"
                      type="button"
                      disabled={isLoading}
                      onClick={() => validateConfirmation()}
                    >
                      Approve
                    </Button>
                  </Grid>
                }
              </form>
            </Card>
          </Grid>
          <Grid xs={4} style={{ paddingLeft: '1rem' }} className='work-model'>
            <Card style={{ padding: '1rem' }}>
              <Typography variant="h4" mb={1}>
                Work Model
              </Typography>
              {wfhConfigurationId ?
                <Calander
                  key={calendarKey}
                  workModelValues={workModelValues}
                  disabled={true}
                /> 
                  : 
                <Card style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                  <Typography fontWeight="light" variant="h4">
                    { workFromHomeValues?.employeeId ? 'No Work Model defined for selected employee'
                     : 'Please select an Employee first to show the work model'}
                  </Typography>
                </Card>
              }
            </Card>
          </Grid>
        </Grid>
      </div>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <WfhRejectReasonForm 
        open={openRejectReasonForm}
        onClose={onCloseRejectReasonForm}
        getData={(e) => {onRejectWfhHandle(e)}}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={validateConfirmation}
        message={`Are you sure want to approved for this WFH request ?`}
        onConfirm={() => onApprovedWfhHandle()}
        noToggle={validateConfirmation}
      />
    </Fragment>
  );
};

export default ApplyWorkFromHome;
  